/**
 * Agency per-client Performance view: the same KPI / attribution / funnel screen the client sees, read through
 * /v1/attribution/agency/clients/:id/* (active consent grant with read:reports; assigned staff only). The funnel also
 * needs manage:billing on the grant; the whole view needs the client's `attribution.dashboard` flag (default off).
 */
import { useMemo } from 'react';
import { Link, useParams } from 'react-router';
import { createPerformanceSource } from '../../../performance/logic';
import { PerformanceView } from '../../../performance/PerformanceView';
import { useSurface } from '../kit/context';
import { Screen } from '../kit/ui';

export function ClientPerformancePage() {
  const { t, locale, now } = useSurface();
  const { id = '' } = useParams();
  const source = useMemo(() => createPerformanceSource({ kind: 'agency', clientId: id }), [id]);
  return (
    <Screen title={t('attribution.perf.title')} subtitle={t('attribution.perf.agencyIntro')} testId="client-performance"
      actions={<Link className="qx-link" to={`/clients/${encodeURIComponent(id)}?tab=summary`}>{t('portal.partners.clients.detail')}</Link>}>
      <PerformanceView source={source} t={t} locale={locale} now={now} integrationsHref="/ads/meta" agency />
    </Screen>
  );
}
